import { render, staticRenderFns } from "./TodoCard.vue?vue&type=template&id=0ee0b126&scoped=true&"
import script from "./TodoCard.vue?vue&type=script&lang=js&"
export * from "./TodoCard.vue?vue&type=script&lang=js&"
import style0 from "./TodoCard.vue?vue&type=style&index=0&id=0ee0b126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee0b126",
  null
  
)

export default component.exports